import { createSlice } from '@reduxjs/toolkit';

const toggleDropdownSlice = createSlice({
  name: 'toggleDropdown',
  initialState: {
    value: 0,
  },
  reducers: {
    setToggle: (state, action) => {
      state.value === action.payload ? (state.value = 0) : (state.value = action.payload);
    },
  },
});

const sliderSlice = createSlice({
  name: 'slider',
  initialState: {
    value: 50,
  },
  reducers: {
    setSliderValue: (state, action) => {
      state.value = action.payload;
    },
  },
});

const todosSlice = createSlice({
  name: 'todos',
  initialState: {
    data: [],
    completed: 0,
  },
  reducers: {
    setTodos: (state, action) => {
      return action.payload;
    },
  },
});

const toggleBalanceSlice = createSlice({
  name: 'toggleBalance',
  initialState: {
    show: true,
  },
  reducers: {
    setSecureMode: (state, action) => {
      return action.payload;
    },
  },
});

const ModalActionsSlice = createSlice({
  name: 'ModalActions',
  initialState: {
    password: '',
    action: '',
  },
  reducers: {
    setModalActions: (state, action) => {
      return action.payload;
    },
  },
});

const walletsSlice = createSlice({
  name: 'wallets',
  initialState: {
    houseMoney: {
      houseMoneyBalance: 0,
      startDate: '',
      targetAmount: 0,
      withdrawalMonth: '',
    },
    flexDollar: {},
  },
  reducers: {
    setHouseMoney: (state, action) => {
      state.houseMoney = action.payload;
    },
    setFlexDollar: (state, action) => {
      state.flexDollar = action.payload;
    },
    setWithdrawalMonth: (state, action) => {
      state.houseMoney.withdrawalMonth = action.payload;
    },
  },
});

const rolesAndPermissionsSlice = createSlice({
  name: 'rolesAndPermissions',
  initialState: {
    roles: '',
  },
  reducers: {
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
  },
});

const USDRequestSlice = createSlice({
  name: 'usdRequests',
  initialState: {
    documents: [],
    currentPage: 1,
    nextPage: 1,
    lastPage: 0,
    total: 0,
  },
  reducers: {
    setUSDRequest: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

const USDHeldRequestSlice = createSlice({
  name: 'usdHeldRequests',
  initialState: {
    requests: [],
    cursor: '',
  },
  reducers: {
    setUSDHeldRequest: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

const USDScrollUtilslice = createSlice({
  name: 'usdRequestsScrollUtils',
  initialState: {
    scrollY: 0,
    isGoBack: false,
  },
  reducers: {
    setUSDRequestScrollUtils: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

const USDRequestMetricsSlice = createSlice({
  name: 'usdRequestsMetrics',
  initialState: {
    total: 0,
    withheld: 0,
    released: 0,
    rejected: 0,
    processing: 0,
    approved: 0,
    returned: 0,
    under_review: 0,
    totalHeld: 0,
  },
  reducers: {
    setUSDRequestMetrics: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

const failedVerificationsSlice = createSlice({
  name: 'failedVerifications',
  initialState: {
    items: [] as Array<{
      id: string;
      source: 'remit' | 'bulk';
      userId: string;
      reason: string;
      amount: number | string;
      month?: string;
      year?: string;
      note?: string;
      totalWithHoldingTax?: number;
      lastBalance?: string;
      totalRemittedAmount?: number;
      row?: number;
    }>,
  },
  reducers: {
    addFailedVerifications: (state, action) => {
      state.items.push(...action.payload);
    },
    resolveFailedVerification: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    clearFailedVerifications: (state) => {
      state.items = [];
    },
  },
});

export const { setToggle } = toggleDropdownSlice.actions;
export const { setSliderValue } = sliderSlice.actions;
export const { setTodos } = todosSlice.actions;
export const { setSecureMode } = toggleBalanceSlice.actions;
export const { setModalActions } = ModalActionsSlice.actions;
export const { setHouseMoney, setFlexDollar } = walletsSlice.actions;
export const { setRoles } = rolesAndPermissionsSlice.actions;
export const { setUSDRequest } = USDRequestSlice.actions;
export const { setUSDRequestScrollUtils } = USDScrollUtilslice.actions;
export const { setUSDHeldRequest } = USDHeldRequestSlice.actions;
export const { setUSDRequestMetrics } = USDRequestMetricsSlice.actions;
export const { addFailedVerifications, resolveFailedVerification, clearFailedVerifications } =
  failedVerificationsSlice.actions;

export default {
  toggleDropdown: toggleDropdownSlice.reducer,
  slider: sliderSlice.reducer,
  todos: todosSlice.reducer,
  toggleBalance: toggleBalanceSlice.reducer,
  modalActions: ModalActionsSlice.reducer,
  wallets: walletsSlice.reducer,
  rolesAndPermissions: rolesAndPermissionsSlice.reducer,
  usdRequests: USDRequestSlice.reducer,
  usdRequestScrollUtils: USDScrollUtilslice.reducer,
  usdHeldRequests: USDHeldRequestSlice.reducer,
  usdRequestsMetrics: USDRequestMetricsSlice.reducer,
  failedVerifications: failedVerificationsSlice.reducer,
};
